import script from "./DatesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DatesBox.vue?vue&type=script&setup=true&lang=js"

import "./DatesBox.vue?vue&type=style&index=0&id=e32a1b0e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e32a1b0e"]])

export default __exports__